import { StyleDeclarationValue, css } from 'aphrodite';
import { observer } from 'mobx-react';
import * as React from 'react';
import { IPostTarget, SupportedSocialMediaTypes } from '../../../extViewmodels';
import { getSocialMediaPlatformLogoUrl } from '../../../models/UiUtils';
import { CreateGhostCalendarSuggestionViewModel } from '../../../viewmodels/AdminViewModels';
import { Checkbox } from '../../../web/components/Checkbox';
import { styleSheet } from './styles';

interface IProps {
	createSuggestion: CreateGhostCalendarSuggestionViewModel;
	styles?: StyleDeclarationValue[];
}

export const GhostCalendarTargets: React.FC<IProps> = observer(props => {
	const { createSuggestion, styles = [] } = props;

	const onTargetOptionClick = (target: IPostTarget) => () => {
		const newTargets = createSuggestion.targets ? [...createSuggestion.targets] : [];
		const index = newTargets.findIndex(x => x?.provider === target.provider);
		if (index >= 0) {
			newTargets.splice(index, 1);
		} else {
			newTargets.push(target);
		}
		createSuggestion.targets = newTargets;
	};

	return (
		<div className={css(styleSheet.container, ...styles)}>
			<div className={css(styleSheet.content)}>
				<div className={css(styleSheet.title)}>Select Social Media Platforms for Post:</div>
				{SupportedSocialMediaTypes.map((target, i) => {
					return (
						<div className={css(styleSheet.flex, styleSheet.itemContainer)} key={`${target}-${i}`}>
							<Checkbox
								checked={!!createSuggestion?.targets?.find(x => x.provider === target)}
								id={`${target}-option-${i}`}
								onChange={onTargetOptionClick({ provider: target })}
							/>
							<button className={css(styleSheet.contentContainer)} onClick={onTargetOptionClick({ provider: target })}>
								<span className={`target ${css(styleSheet.pill)}`}>
									<img src={getSocialMediaPlatformLogoUrl(target)} />
									{target}
								</span>
							</button>
						</div>
					);
				})}
			</div>
			<p className={css(styleSheet.textLight)}>
				If a user isn&apos;t connected to a selected social media platform, it will revert to only those with
				connections.
			</p>
		</div>
	);
});
